import React from "react";

/**
 * HealthScoreBadge — Circular indicator with score and level color.
 * Props: score (0-100 | null), level ("green"|"orange"|"red"|"unknown"), size (px, default 56).
 */
export function HealthScoreBadge({ score, level = "unknown", size = 56, testID = "health-badge" }) {
  const color =
    level === "green" ? "var(--mf-ok-solid)" :
    level === "orange" ? "var(--mf-upcoming-solid)" :
    level === "red" ? "var(--mf-urgent-solid)" : "var(--mf-border)";
  const bg =
    level === "green" ? "var(--mf-ok-bg)" :
    level === "orange" ? "var(--mf-upcoming-bg)" :
    level === "red" ? "var(--mf-urgent-bg)" : "var(--mf-bg-muted)";
  const shown = typeof score === "number" ? `${score}%` : "—";
  const radius = size / 2 - 4;
  const circumference = 2 * Math.PI * radius;
  const progress = typeof score === "number" ? Math.max(0, Math.min(100, score)) / 100 : 0;
  const dashoffset = circumference * (1 - progress);
  return (
    <div
      data-testid={testID}
      data-level={level}
      style={{
        position: "relative", width: size, height: size,
        display: "inline-flex", alignItems: "center", justifyContent: "center",
      }}
    >
      <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} style={{ position: "absolute", inset: 0 }}>
        <circle cx={size / 2} cy={size / 2} r={radius} fill={bg} stroke="none" />
        <circle
          cx={size / 2} cy={size / 2} r={radius}
          fill="none" stroke={color} strokeWidth={4} strokeLinecap="round"
          strokeDasharray={circumference} strokeDashoffset={dashoffset}
          transform={`rotate(-90 ${size / 2} ${size / 2})`}
          style={{ transition: "stroke-dashoffset 500ms cubic-bezier(0.16,1,0.3,1)" }}
        />
      </svg>
      <span style={{
        fontSize: size >= 72 ? 18 : 13, fontWeight: 800,
        color, letterSpacing: -0.3, zIndex: 1,
      }} data-testid={`${testID}-value`}>
        {shown}
      </span>
    </div>
  );
}

export function HealthDisclaimer({ testID = "health-disclaimer" }) {
  return (
    <div
      data-testid={testID}
      style={{
        fontSize: 11, color: "var(--mf-text-muted)", fontStyle: "italic",
        lineHeight: 1.5, padding: "8px 12px", background: "var(--mf-bg-muted)",
        borderRadius: 10, marginTop: 8,
      }}
    >
      Estimation basée sur votre usage et les intervalles configurés. Vérifiez les recommandations du constructeur.
    </div>
  );
}
